import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Breadcrumbs from './Breadcrumbs';
import Container from './container';
export default function LayoutWithSidebar({ header, sidebar, children, breadcrumbs, footer, className, }) {
    return (React.createElement(Container, { className: classnames(className) },
        breadcrumbs && React.createElement(Breadcrumbs, { breadcrumbs: breadcrumbs }),
        header && header(),
        sidebar && (React.createElement("div", { className: "lg:grid lg:grid-cols-5 lg:gap-6" },
            React.createElement("div", { className: "lg:col-span-1" }, sidebar()),
            React.createElement("div", { className: "lg:col-span-4" }, children))),
        !sidebar && children,
        footer && footer()));
}
LayoutWithSidebar.propTypes = {
    children: PropTypes.node,
    sidebar: PropTypes.func,
    className: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object,
        PropTypes.string,
    ]),
    Breadcrumbs: PropTypes.shape({
        homeTitle: PropTypes.string,
        homeUrl: PropTypes.string,
        pages: PropTypes.arrayOf(PropTypes.shape({
            name: PropTypes.string.isRequired,
        })),
    }),
};
